/* istanbul ignore file */
import React, { useEffect } from 'react';
import defaultStyles from 'commonStyles/components/coupon/_loyalty-simplified';
import { sendLoyaltyModalEvent, sendLoyaltyProgramEvent } from 'common/util/gtm-helper';
import styleOverrides from 'styles/components/coupon/_loyalty-simplified';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import Button from 'common/components/atoms/button';
import PropTypes from 'prop-types';
import { translate } from 'common/localization';

const LoyaltyCouponSimplifiedSuccess = ({
  bodyText,
  disclaimers,
  handleContinue,
  cta,
}) => {
  const styles = useStyleOverrides(defaultStyles, styleOverrides);

  useEffect(() => {
    sendLoyaltyModalEvent('impression', 'success');
    sendLoyaltyProgramEvent('apply coupon 20', 'coupon 20 modal');
  }, []);

  const handleSuccess = () => {
    handleContinue();
    sendLoyaltyModalEvent('keep shopping click', 'success');
  };

  return (<>
    <p className={styles.couponDescription}>
      {bodyText.success}
    </p>
    <Button
      onClick={handleSuccess}
      className={styles.successCtaLink}
    >
      {translate('label.continue.shopping')}
    </Button>
    <a
      className={styles.eligibleMutedLink}
      target="_blank"
      rel="noopener noreferrer"
      href={cta.eligibleLink}
      onClick={() => {
        sendLoyaltyProgramEvent('show eligible items click', 'success');
      }}
    >
      {translate('label.shop.eligible')}
    </a>
    <div className={styles.disclaimer}>
      <span>
        {disclaimers.success}
      </span>
    </div>
    </>
  );
};

LoyaltyCouponSimplifiedSuccess.propTypes = {
  bodyText: PropTypes.shape({}),
  disclaimers: PropTypes.shape({}),
  cta: PropTypes.shape({}),
  handleContinue: PropTypes.func.isRequired,
};

export default LoyaltyCouponSimplifiedSuccess;
